import { createAction } from 'redux-actions'

const ns = 'user-management/'

export const getCompanyUsers = createAction(`${ns}GET_COMPANY_USERS`)
export const getCompanyUsersSuccess = createAction(`${ns}GET_COMPANY_USERS_SUCCESS`)
export const getCompanyUsersFail = createAction(`${ns}GET_COMPANY_USERS_FAIL`)

export const setCompanyUsersLoading = createAction(`${ns}SET_COMPANY_USERS_LOADING`)

export const deleteUser = createAction(`${ns}DELETE_USER`)

export const toggleUserStatus = createAction(`${ns}TOGGLE_USER_STATUS`)
export const setUserCountry = createAction(`${ns}SET_USER_COUNTRY`)
export const setUserDivision = createAction(`${ns}SET_USER_DIVISION`)

export const getCompanySignUpCode = createAction(`${ns}GET_COMPANY_SIGN_UP_CODE`)
export const getCompanySignUpCodeSuccess = createAction(`${ns}GET_COMPANY_SIGN_UP_CODE_SUCCESS`)
